import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/sort-icon-1.png';
import _imports_1 from '@/assets/images/sort-icon-3.png';
import _imports_2 from '@/assets/images/sort-icon-2.png';

const _withScopeId = n => (_pushScopeId("data-v-e197ec9e"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  style: {
    "min-height": "100%"
  }
};
const _hoisted_2 = {
  class: "homebox clearfix"
};
const _hoisted_3 = {
  class: "owin-height"
};
const _hoisted_4 = {
  class: "course-top"
};
const _hoisted_5 = {
  class: "course-main-title"
};
const _hoisted_6 = {
  key: 0,
  class: "line-icon"
};
const _hoisted_7 = {
  key: 1,
  class: "text"
};
const _hoisted_8 = {
  class: "english-name"
};
const _hoisted_9 = {
  class: "course-wrapper"
};
const _hoisted_10 = {
  key: 0,
  class: "menu-list-out"
};
const _hoisted_11 = {
  class: "menu-list"
};
const _hoisted_12 = {
  class: "course-box"
};
const _hoisted_13 = {
  key: 0,
  class: "show-classify"
};
const _hoisted_14 = {
  class: "classify-box"
};
const _hoisted_15 = {
  ref: "classify-list-dom",
  class: "classify-list-dom"
};
const _hoisted_16 = ["onClick", "title"];

const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-arrow-down"
}, null, -1));

const _hoisted_18 = {
  class: "course-filter"
};
const _hoisted_19 = {
  class: "left"
};
const _hoisted_20 = {
  class: "course-total"
};

const _hoisted_21 = /*#__PURE__*/_createTextVNode(" 找到约 ");

const _hoisted_22 = /*#__PURE__*/_createTextVNode(" 条相关结果 ");

const _hoisted_23 = {
  class: "course-sort"
};
const _hoisted_24 = {
  key: 0,
  class: "sort-icon",
  src: _imports_0,
  alt: ""
};
const _hoisted_25 = {
  key: 1,
  class: "sort-icon",
  src: _imports_1,
  alt: ""
};
const _hoisted_26 = {
  key: 2,
  class: "sort-icon",
  src: _imports_2,
  alt: ""
};
const _hoisted_27 = {
  key: 1,
  class: "no-data"
};
const _hoisted_28 = {
  key: 1,
  class: "no-data"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_LeftMenuItem = _resolveComponent("LeftMenuItem");

  const _component_el_affix = _resolveComponent("el-affix");

  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");

  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");

  const _component_el_dropdown = _resolveComponent("el-dropdown");

  const _component_CourseCard = _resolveComponent("CourseCard");

  const _component_Empty = _resolveComponent("Empty");

  const _component_SpocCard = _resolveComponent("SpocCard");

  const _component_el_pagination = _resolveComponent("el-pagination");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [$data.classify_flag !== '1' ? (_openBlock(), _createElementBlock("div", _hoisted_6)) : _createCommentVNode("", true), $data.classify_flag !== '1' ? (_openBlock(), _createElementBlock("span", _hoisted_7, [_createTextVNode(_toDisplayString($data.menuInfo.nav_name) + "  ", 1), _createElementVNode("span", _hoisted_8, _toDisplayString($data.courseType == 1 ? '/ Course Center' : '/  Everyone Gold Class'), 1)])) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_9, [$data.organ_flag == 1 || $data.results_flag == 1 || $data.subject_flag == 1 || $data.term_flag == 1 ? (_openBlock(), _createBlock(_component_el_affix, {
    key: 0,
    offset: 80
  }, {
    default: _withCtx(() => [$data.menuDataLoaded ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [$data.organ_flag == 1 && $data.menuDataLoaded ? (_openBlock(), _createBlock(_component_LeftMenuItem, {
      key: 0,
      menuData: $data.categoryData,
      checkedId: $data.searchInfo.collegeId,
      onCheckedChange: $options.collegeChange
    }, null, 8, ["menuData", "checkedId", "onCheckedChange"])) : _createCommentVNode("", true), $data.courseType == 2 && $data.term_flag == 1 && $data.menuDataLoaded ? (_openBlock(), _createBlock(_component_LeftMenuItem, {
      key: 1,
      menuData: $data.termData,
      checkedId: $data.searchInfo.semester,
      onCheckedChange: $options.termChange
    }, null, 8, ["menuData", "checkedId", "onCheckedChange"])) : _createCommentVNode("", true), $data.results_flag == 1 && $data.menuDataLoaded ? (_openBlock(), _createBlock(_component_LeftMenuItem, {
      key: 2,
      menuData: $data.achievementKindData,
      checkedId: $data.searchInfo.courseResultsId,
      onCheckedChange: $options.courseResultChange
    }, null, 8, ["menuData", "checkedId", "onCheckedChange"])) : _createCommentVNode("", true), $data.subject_flag == 1 && $data.menuDataLoaded ? (_openBlock(), _createBlock(_component_LeftMenuItem, {
      key: 3,
      menuData: $data.subjectData,
      checkedId: $data.searchInfo.subjectId,
      onCheckedChange: $options.oneSubjectChange,
      isLast: true
    }, null, 8, ["menuData", "checkedId", "onCheckedChange"])) : _createCommentVNode("", true)])])) : _createCommentVNode("", true)]),
    _: 1
  })) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_12, [$data.classify_flag == '1' ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createElementVNode("div", {
    class: _normalizeClass(["show-list", $data.hiddenMoreClass && 'hidden'])
  }, [_createElementVNode("div", _hoisted_15, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.classifyList, item => {
    return _openBlock(), _createElementBlock("span", {
      key: item.id,
      class: _normalizeClass(["list-item text-overflow", {
        active: $data.classifyId === item.id
      }]),
      onClick: $event => $options.searchCourseList(item.id),
      title: item.name
    }, _toDisplayString(item.name), 11, _hoisted_16);
  }), 128))], 512)], 2), $data.showMoreBtn ? (_openBlock(), _createElementBlock("span", {
    key: 0,
    class: _normalizeClass(["show-more-btn", !$data.hiddenMoreClass && 'hidden']),
    onClick: _cache[0] || (_cache[0] = $event => $data.hiddenMoreClass = !$data.hiddenMoreClass)
  }, [_createTextVNode(_toDisplayString($data.hiddenMoreClass ? '展开' : '收起') + " ", 1), _hoisted_17], 2)) : _createCommentVNode("", true)])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_hoisted_21, _createElementVNode("span", null, _toDisplayString($data.pageInfo.rows), 1), _hoisted_22]), _createElementVNode("div", _hoisted_23, [$data.searchInfo.sortNum == 3 ? (_openBlock(), _createElementBlock("img", _hoisted_24)) : $data.searchInfo.sortNum == 2 ? (_openBlock(), _createElementBlock("img", _hoisted_25)) : (_openBlock(), _createElementBlock("img", _hoisted_26)), _createVNode(_component_el_dropdown, {
    trigger: "hover",
    "append-to-body": false,
    "show-arrow": false
  }, {
    dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.courseType == 1 ? $data.sortTypeList : $data.spocSortTypeList, (item, index) => {
        return _openBlock(), _createBlock(_component_el_dropdown_item, {
          key: item.name,
          onClick: $event => $options.handleSort(item, index)
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(item.name), 1)]),
          _: 2
        }, 1032, ["onClick"]);
      }), 128))]),
      _: 1
    })]),
    default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString($data.searchInfo.sortName), 1)]),
    _: 1
  })])])]), _createElementVNode("div", null, [$data.courseType == '1' && $data.courseList.length ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: _normalizeClass(["course-list", $data.organ_flag == 2 && $data.results_flag == 2 && $data.subject_flag == 2 ? 'course-list-no' : 'course-list-yes'])
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.courseList, course => {
    return _openBlock(), _createBlock(_component_CourseCard, {
      userInfo: $data.userInfo,
      "course-data": course,
      key: course.courseId,
      authType: $data.authType,
      showResultTag: $data.showResultTag,
      resultMap: $data.resultMap
    }, null, 8, ["userInfo", "course-data", "authType", "showResultTag", "resultMap"]);
  }), 128))], 2)) : _createCommentVNode("", true), $data.courseType == 1 && !$data.courseList.length ? (_openBlock(), _createElementBlock("div", _hoisted_27, [_createVNode(_component_Empty)])) : _createCommentVNode("", true)]), _createElementVNode("div", null, [$data.courseType == '2' && $data.courseList.length ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: _normalizeClass(["course-list", $data.organ_flag == 2 && $data.results_flag == 2 && $data.subject_flag == 2 && $data.term_flag == 2 ? 'course-list-no' : 'course-list-yes'])
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.courseList, course => {
    return _openBlock(), _createBlock(_component_SpocCard, {
      userInfo: $data.userInfo,
      info: course,
      key: course.courseId,
      authType: $data.authType,
      showResultTag: $data.showResultTag,
      resultMap: $data.resultMap
    }, null, 8, ["userInfo", "info", "authType", "showResultTag", "resultMap"]);
  }), 128))], 2)) : _createCommentVNode("", true), $data.courseType == '2' && !$data.courseList.length ? (_openBlock(), _createElementBlock("div", _hoisted_28, [_createVNode(_component_Empty)])) : _createCommentVNode("", true)]), $data.pageInfo.rows > $data.pageInfo.pageLimit ? (_openBlock(), _createBlock(_component_el_pagination, {
    key: 1,
    class: "course-pagination",
    background: "",
    layout: "prev, pager, next",
    "prev-text": "上一页",
    "next-text": "下一页",
    "page-size": $data.pageInfo.pageLimit,
    onCurrentChange: $options.pageIndexChange,
    "current-page": $data.pageInfo.pageIndex,
    total: 0 || $data.pageInfo.rows
  }, null, 8, ["page-size", "onCurrentChange", "current-page", "total"])) : _createCommentVNode("", true)])])])])]);
}